<mat-label class="title d-block mt-0 mt-md-5 mb-4">{{ 'claimConfirm.title' | translate }}</mat-label>
<form [formGroup]="form">
	<div class="row" *ngIf="claimConfirmPart === 1">
		<div class="col-12 ps-0">
			<p>
				{{ 'claimConfirm.repairDescription' | translate }}
			</p>
		</div>
		<div class="col-12 ps-0 mt-4">
			<p class="fw-bold mb-2">{{ 'claimConfirm.repairman.question' | translate }}</p>
			<div class="form-check">
				<input
					class="form-check-input"
					type="radio"
					id="radioSendFixerYes"
					formControlName="sendFixer"
					[value]="true"
					(click)="setSendFixer(true)"
				/>
				<label class="form-check-label ms-2 mt-1" for="radioSendFixerYes">
					{{ 'claimConfirm.repairman.answerYes' | translate }}
				</label>
			</div>
			<div class="form-check mt-2">
				<input
					class="form-check-input"
					type="radio"
					id="radioSendFixerNo"
					formControlName="sendFixer"
					[value]="false"
					(click)="setSendFixer(false)"
				/>
				<label class="form-check-label ms-2 mt-1" for="radioSendFixerNo">
					{{ 'claimConfirm.repairman.answerNo' | translate }}
				</label>
			</div>
			<ngb-alert
				type="info"
				[dismissible]="false"
				class="col-12 col-md-6 d-flex mt-4"
				*ngIf="form.value?.sendFixer === false"
			>
				<i class="icon hs-icon-info"></i>
				<span [innerHTML]="'claimConfirm.documentationMsg' | translate"></span>
			</ngb-alert>
			<ngb-alert
				type="info"
				[dismissible]="false"
				class="col-12 col-md-6 d-flex mt-4"
				*ngIf="form.value?.sendFixer === true"
			>
				<i class="icon hs-icon-info"></i>
				<span [innerHTML]="'claimConfirm.disclaimer.confirm' | translate"></span>
			</ngb-alert>
		</div>
		<div class="col-12 ps-0 mt-4">
			<button
				type="button"
				class="btn btn-outline-primary w-100 w-md-initial"
				[disabled]="form.get('sendFixer')?.invalid"
				(click)="form.value?.sendFixer === true ? updateClaimConfirmPart(2) : updateClaimConfirmPart(3)"
			>
				{{ 'common.confirm' | translate }}
			</button>
		</div>
	</div>

	<div class="row" *ngIf="claimConfirmPart === 2">
		<div class="col-12 ps-0">
			<p>
				{{ 'claimConfirm.sendRepairmanDesc' | translate }}
			</p>
		</div>
		<div class="col-12 ps-0 mt-4">
			<p class="fw-bold mb-2">{{ 'claimConfirm.noRepairDmg.question' | translate }}</p>
			<div class="form-check">
				<input
					class="form-check-input"
					type="radio"
					id="radioisExistsRepairYes"
					formControlName="isExistsRepair"
					[value]="true"
				/>
				<!-- (click)="setDmgNoNeedReparable($event)" -->
				<label class="form-check-label ms-2 mt-1" for="radioisExistsRepairYes">
					{{ 'claimConfirm.noRepairDmg.answerYes' | translate }}
				</label>
			</div>
			<div class="form-check mt-2">
				<input
					class="form-check-input"
					type="radio"
					id="radioisExistsRepairNo"
					formControlName="isExistsRepair"
					[value]="false"
				/>
				<!-- (click)="setDmgNoNeedReparable($event)" -->
				<label class="form-check-label ms-2 mt-1" for="radioisExistsRepairNo">
					{{ 'claimConfirm.noRepairDmg.answerNo' | translate }}
				</label>
			</div>
		</div>
		<div class="col-12 ps-0 mt-4">
			<p class="fw-bold mb-2">
				{{ 'claimConfirm.builtHomeQuestion' | translate }}
			</p>
			<div class="form-check">
				<input
					class="form-check-input"
					type="radio"
					id="radioisProfOrRestoreHomeYes"
					formControlName="isProfOrRestoreHome"
					[value]="true"
				/>
				<label class="form-check-label ms-2 mt-1" for="radioisProfOrRestoreHomeYes">
					{{ 'common.yes' | translate }}
				</label>
			</div>
			<div class="form-check mt-2">
				<input
					class="form-check-input"
					type="radio"
					id="radioisProfOrRestoreHomeNo"
					formControlName="isProfOrRestoreHome"
					[value]="false"
				/>
				<label class="form-check-label ms-2 mt-1" for="radioisProfOrRestoreHomeNo">
					{{ 'common.no' | translate }}
				</label>
			</div>
		</div>
		<div class="col-12 ps-0 mt-4 d-flex">
			<button
				type="button"
				class="btn btn-outline-primary w-100 w-md-initial ms-3"
				[disabled]="form.get('isExistsRepair')?.invalid || form.get('isProfOrRestoreHome')?.invalid"
				(click)="updateClaimConfirmPart(3)"
			>
				{{ 'common.confirm' | translate }}
			</button>
		</div>
	</div>

	<!-- STEPPER SINIESTRO INDEMNIZABLE -->

	<div *ngIf="claimConfirmPart === 3 && form.get('sendFixer')?.value !== undefined && !form.get('sendFixer')?.value">
		<div class="d-flex align-items-center justify-content-between w-100">
			<span class="subtitle">{{ 'claimConfirm.requiredDocs.title' | translate }}</span>
		</div>
		<div class="row" *ngIf="!showStepSummary['attachDescription']['show']">
			<div class="col-12 col-md-6">
				<p class="mt-3 mb-2">{{ 'claimConfirm.requiredDocs.later' | translate }}</p>
				<ul>
					<li *ngFor="let doc of docs">
						<span class="fw-medium">{{ 'docs.'+doc.id | translate }}</span>
					</li>
				</ul>
				<p class="fw-bold fs-6 m-0 mt-4">{{ 'claimConfirm.requiredDocs.send' | translate }}</p>
				<p class="mt-2 mb-2" [innerHTML]="'claimConfirm.requiredDocs.mailLink' | translate"></p>
			</div>
		</div>
	</div>
	<div
		class="row"
		*ngIf="claimConfirmPart === 3 && form.get('sendFixer')?.value !== undefined && !form.get('sendFixer')?.value"
	>
		<div class="col-12 p-0 pt-4 mt-4 border-top d-flex justify-content-end">
			<button
				(click)="onSubmit(true)"
				class="btn btn-primary d-flex align-items-center justify-content-center w-100 w-md-initial"
			>
				<i class="icon hs-icon-check text-white"></i>
				{{ 'claimConfirm.send' | translate }}
			</button>
		</div>
	</div>

	<!-- FIN STEPPER SINIESTRO INDEMNIZABLE -->

	<mat-stepper
		#stepper
		*ngIf="claimConfirmPart === 3 && form.get('sendFixer')?.value"
		orientation="vertical"
		animationDuration="0"
		class="stepper stepper-vertical"
	>
		<mat-step
			*ngIf="form.get('isExistsRepair')?.value"
			[completed]="showStepSummary['attachDescription']['show'] && !showStepSummary['attachDescription']['empty']"
			[editable]="false"
		>
			<div class="container-link-modify" *ngIf="showStepSummary['attachDescription']['show']">
				<span class="link fw-normal fs-6 text-primary" (click)="hideSummary('attachDescription')">{{
					'common.modify' | translate
				}}</span>
			</div>
			<ng-template matStepLabel>
				<div class="d-flex align-items-center justify-content-between w-100">
					<span class="title">{{ 'claimConfirm.requiredDocs.title' | translate }}</span>
				</div>
			</ng-template>
			<ng-template matStepContent>
				<div class="row" *ngIf="!showStepSummary['attachDescription']['show']">
					<div class="col-12 col-md-6">
						<p class="mt-3 mb-2">{{ 'claimConfirm.requiredDocs.later' | translate }}</p>
						<ul>
							<li *ngFor="let doc of docs">
						<span class="fw-medium">{{ 'docs.'+doc.id | translate }}</span>
					</li>
						</ul>
						<p class="fw-bold fs-6 m-0 mt-4">{{ 'claimConfirm.requiredDocs.send' | translate }}</p>
						<p class="mt-2 mb-2" [innerHTML]="'claimConfirm.requiredDocs.mailLink' | translate"></p>
						<div class="col-12 ps-0 mt-4">
							<button
								type="button"
								matStepperNext
								class="btn btn-outline-primary w-100 w-md-initial"
								(click)="showSummary('attachDescription')"
							>
								{{ 'common.confirm' | translate }}
							</button>
						</div>
					</div>
				</div>
				<div
					class="row"
					*ngIf="showStepSummary['attachDescription']['show'] && !showStepSummary['attachDescription']['empty']"
				>
					<div class="col-12 col-md-6">
						<p class="mt-3 mb-2">{{ 'claimConfirm.requiredDocs.later' | translate }}</p>
						<ul>
							<li *ngFor="let doc of docs">
								<span class="fw-medium">{{ 'docs.'+doc.id | translate }}</span>
							</li>
						</ul>
					</div>
				</div>
			</ng-template>
		</mat-step>

		<mat-step
			*ngIf="!isOnlyIndemnizable"
			[completed]="showStepSummary['claimRepairData']['show'] && !showStepSummary['claimRepairData']['empty']"
			[editable]="false"
		>
			<div class="container-link-modify" *ngIf="showStepSummary['claimRepairData']['show']">
				<span class="link fw-normal fs-6 text-primary" (click)="hideSummary('claimRepairData')">{{
					'common.modify' | translate
				}}</span>
			</div>
			<ng-template matStepLabel>
				<div class="d-flex align-items-center justify-content-between w-100">
					<span class="title">{{ 'claimConfirm.repairDmg.title' | translate }}</span>
				</div>
			</ng-template>
			<ng-template matStepContent>
				<div class="row" *ngIf="!showStepSummary['claimRepairData']['show']">
					<div class="col-12">
						<p class="fs-6 m-0" [innerHTML]="'claimConfirm.repairDmg.selectTechnician' | translate"></p>

						<div class="row">
							<div class="col-12 col-md-6 col-xl-3 mt-2 mb-3 p-0">
								<div class="d-flex align-items-center justify-content-between">
									<label for="exampleFormControlInput1" class="form-label">{{
										'claimConfirm.repairDmg.technician' | translate
									}}</label>
								</div>
								<div *ngIf="technicians.length > 1" ngbDropdown>
									<button type="button" class="btn btn-light w-100" id="dropdownBasic1" ngbDropdownToggle>
										{{ technicianSelected ? ('guild.'+technicianSelected | translate) : ('claimConfirm.repairDmg.selectLiteral' | translate) }}
									</button>
									<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
										<button ngbDropdownItem *ngFor="let technician of technicians" (click)="setTechnician(technician)">
											{{ 'guild.'+technician | translate }}
										</button>
									</div>
								</div>
								<div *ngIf="technicians.length === 1">
									{{ 'guild.'+technicians[0] | translate }}
								</div>
							</div>
						</div>
					</div>

					<div class="col-12 mt-4">
						<button
							[disabled]="!form.get('technician')?.value"
							type="button"
							matStepperNext
							class="btn btn-outline-primary w-100 w-md-initial"
							(click)="showSummary('claimRepairData')"
						>
							{{ 'common.confirm' | translate }}
						</button>
					</div>
				</div>
				<div
					class="row"
					*ngIf="showStepSummary['claimRepairData']['show'] && !showStepSummary['claimRepairData']['empty']"
				>
					<div class="col-12">
						<p class="fs-6 m-0">
							{{ 'claimConfirm.repairDmg.summary' | translate }}
							<b>{{ 'guild.'+technicianSelected | translate }}</b>
						</p>
					</div>
				</div>
			</ng-template>
		</mat-step>

		<mat-step
			*ngIf="!isOnlyIndemnizable"
			[completed]="showStepSummary['repairAppointment']['show'] && !showStepSummary['repairAppointment']['empty']"
			[editable]="false"
		>
			<div class="container-link-modify" *ngIf="showStepSummary['repairAppointment']['show']">
				<span class="link fw-normal fs-6 text-primary" (click)="hideSummary('repairAppointment')">{{
					'common.modify' | translate
				}}</span>
			</div>
			<ng-template matStepLabel>
				<div class="d-flex align-items-center justify-content-between w-100">
					<span class="title">{{ 'claimConfirm.appointment.title' | translate }}</span>
				</div>
			</ng-template>
			<ng-template matStepContent>
				<div class="row" *ngIf="!showStepSummary['repairAppointment']['show']">
					<fieldset [disabled]="appointmentNotAvailable">
						<div class="col-12">
							<p class="fs-6 m-0">
								{{ 'claimConfirm.appointment.professionalDate.description' | translate }}
							</p>
							<p class="fw-bold mt-3 mb-2">{{ 'claimConfirm.appointment.professionalDate.question' | translate }}</p>
							<div class="form-check">
								<input
									class="form-check-input"
									type="radio"
									name="radioDateProfessional"
									[value]="true"
									id="radioDateProfessionalYes"
									(click)="setDateProfessional($event)"
									formControlName="radioDateProfessional"
								/>
								<label class="form-check-label ms-2 mt-1" for="radioDateProfessionalYes">
									{{ 'claimConfirm.appointment.professionalDate.yes' | translate }}
								</label>
							</div>
							<div class="form-check mt-2 mb-4">
								<input
									class="form-check-input"
									type="radio"
									name="radioDateProfessional"
									[value]="false"
									id="radioDateProfessionalNo"
									formControlName="radioDateProfessional"
								/>
								<label class="form-check-label ms-2 mt-1" for="radioDateProfessionalNo">
									{{ 'claimConfirm.appointment.professionalDate.no' | translate }}
								</label>
							</div>
						</div>
					</fieldset>		
					<div
						class="row p-0"
						*ngIf="
							this.form.get('radioDateProfessional')?.value !== (undefined || null) &&
							!this.form.get('radioDateProfessional')?.value
						"
					>
						<div class="col-12 col-md-6 col-xl-3 mb-3">
							<div class="d-flex align-items-center justify-content-between">
								<label class="form-label">{{
									'claimConfirm.appointment.noProfessionalDate.questionDate' | translate
								}}</label>
								<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
							</div>
							<div class="input-group">
								<input
									[readonly] = "true"
									[markDisabled]="isDisabled"
									class="form-control"
									placeholder="dd/mm/yyyy"
									name="dp"
									ngbDatepicker
									#d="ngbDatepicker"
									placement="bottom"
									container="body"
									[minDate]="nextDayAvailableObject"
									formControlName="callDate"
								/>
								<button class="btn btn-light btn-calendar d-flex" (click)="d.toggle()" type="button">
									<i class="icon hs-icon-calendar"></i>
								</button>
							</div>
						</div>
					</div>
					<div
						class="row p-0"
						*ngIf="
							this.form.get('radioDateProfessional')?.value !== (undefined || null) &&
							!this.form.get('radioDateProfessional')?.value
						"
					>
						<div class="col-12 col-md-6 col-xl-3 mb-3">
							<div class="d-flex align-items-center justify-content-between">
								<label for="dropdownCallTime" class="form-label">{{
									'claimConfirm.appointment.noProfessionalDate.questionHour' | translate
								}}</label>
								<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
							</div>
							<div ngbDropdown>
								<button type="button" class="btn btn-light w-100" id="dropdownCallTime" ngbDropdownToggle>
									{{
										form.get('callTime')?.value
											? form.get('callTime')?.value
											: ('claimConfirm.appointment.noProfessionalDate.selectDate' | translate)
									}}
								</button>
								<div ngbDropdownMenu aria-labelledby="dropdownCallTime">
									<button ngbDropdownItem (click)="setCallTimeValue('common.dayRange.morning')">
										{{ 'common.dayRange.morning' | translate }}
									</button>
									<button ngbDropdownItem (click)="setCallTimeValue('common.dayRange.afternoon')">
										{{ 'common.dayRange.afternoon' | translate }}
									</button>
									<button ngbDropdownItem (click)="setCallTimeValue('common.dayRange.indifferent')">
										{{ 'common.dayRange.indifferent' | translate }}
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-xl-6 mt-4" *ngIf="this.form.get('radioDateProfessional')?.value">
						<div class="calendar-appointment" *ngIf="timeZones.length > 0">
							<div
								class="d-flex align-items-start align-items-md-center justify-content-between flex-column flex-md-row w-100"
							>
								<p *ngIf="!showCarouselByDays">{{ 'claimConfirm.appointment.professionalDate.title' | translate }}</p>
								<p class="fw-bold fs-6 m-0" *ngIf="showCarouselByDays">
									{{ 'claimConfirm.appointment.professionalDate.selectDayHour' | translate }}
								</p>
								<button class="btn px-0" *ngIf="!showCarouselByDays" (click)="fnShowCarouselByDays()">
									<span class="fs-6 text-primary text-decoration-underline">{{
										'claimConfirm.appointment.professionalDate.moreOptions' | translate
									}}</span>
								</button>
							</div>
							<div *ngIf="!showCarouselByDays">
								<span class="fw-bold fs-6 m-0" style="text-transform: capitalize"
									>{{ weekDaySelected }} {{ daySelected }}</span
								>
							</div>
							<div class="container-carousel-by-days mb-5" *ngIf="showCarouselByDays">
								<div class="container-carousel-filter">
									<div class="row">
										<div class="col-12 col-md-5 d-flex justify-content-center justify-content-md-start">
											<div class="container-carousel-months">
												<i class="icon hs-icon-calendar carousel-months-icon"></i>
												<owl-carousel-o (changed)="setMonthSelected($event)" [options]="customOptionsFilter">
													<ng-template carouselSlide [id]="month" *ngFor="let month of availableMonthNames">
														{{ month }}
													</ng-template>
												</owl-carousel-o>
											</div>
										</div>
										<div class="col-12 col-md-7 d-flex justify-content-center justify-content-md-end">
											<div class="form-check">
												<input
													class="form-check-input"
													type="radio"
													name="radioDayRange"
													value="morning"
													id="radioDayRangeMorning"
													(click)="setDayRange($event)"
												/>
												<label class="form-check-label ms-2 mt-1" for="radioDayRangeMorning">
													{{ 'common.dayRange.morning' | translate }}
												</label>
											</div>
											<div class="form-check ms-4">
												<input
													class="form-check-input"
													type="radio"
													name="radioDayRange"
													value="afternoon"
													id="radioDayRangeAfternoon"
													(click)="setDayRange($event)"
												/>
												<label class="form-check-label ms-2 mt-1" for="radioDayRangeAfternoon">
													{{ 'common.dayRange.afternoon' | translate }}
												</label>
											</div>
											<div class="form-check ms-4">
												<input
													class="form-check-input"
													type="radio"
													name="radioDayRange"
													value="all"
													id="radioDayRangeAll"
													(click)="setDayRange($event)"
													checked
												/>
												<label class="form-check-label ms-2 mt-1" for="radioDayRangeAll">
													{{ 'common.dayRange.all' | translate }}
												</label>
											</div>
										</div>
									</div>
								</div>

								<div class="container-carousel mt-4">
									<owl-carousel-o [options]="customOptions">
										<ng-template
											carouselSlide
											[id]="
												day['startDate'].toLocaleString('default', { day: '2-digit' }) +
												day['startDate'].toLocaleString('default', { month: '2-digit' })
											"
											*ngFor="let day of availableDays"
										>
											<div
												class="card"
												[ngClass]="{
													active:
														day['startDate'].toLocaleString('default', { day: '2-digit' }) === daySelected &&
														day['startDate'].toLocaleString('default', { month: 'long' }) === monthSelected
												}"
												(click)="
													setDaySelected(
														day['startDate'].toLocaleString('default', { day: '2-digit' }),
														setDayName(day['startDate'], 'long')
													)
												"
											>
												<div class="card-body">
													<p class="day">{{ setDayName(day['startDate'], 'short') }}</p>
													<p class="day-number">{{ day['startDate'].getDate() }}</p>
												</div>
											</div>
										</ng-template>
									</owl-carousel-o>
								</div>
							</div>

							<p class="fw-bold fs-6" *ngIf="showCarouselByDays && daySelected !== ''">
								{{ 'claimConfirm.appointment.professionalDate.availableHours' | translate }}
							</p>
							<div class="container-button-hour" *ngIf="daySelected !== ''">
								<button
									class="btn"
									[ngClass]="{ active: hour === hourSelected && !dayChanged && !monthChanged }"
									*ngFor="let hour of availableHoursFormatted"
									(click)="setHourSelected(hour)"
								>
									<span>{{ hour }}</span>
								</button>
								<span *ngIf="availableHoursFormatted.length === 0">{{
									'claimConfirm.appointment.professionalDate.notAvailable' | translate
								}}</span>
							</div>
						</div>
					</div>
					<div class="col-12 mt-4">
						<button
							[disabled]="!this.form.get('appointment')?.get('startHour')?.value && !form.get('callTime')?.value"
							type="button"
							class="btn btn-outline-primary w-100 w-md-initial"
							(click)="showSummary('repairAppointment')"
						>
							{{ 'common.confirm' | translate }}
						</button>
					</div>
				</div>
				<div
					class="row"
					*ngIf="showStepSummary['repairAppointment']['show'] && !showStepSummary['repairAppointment']['empty']"
				>
					<div
						class="col-12"
						*ngIf="form.get('radioDateProfessional')?.value && daySelected && monthSelected && hourSelected"
					>
						<p class="fs-6 m-0">
							<span style="text-transform: capitalize">{{ weekDaySelected }}</span> {{ daySelected }}
							{{ 'common.of' | translate }} {{ monthSelected }} {{ 'common.between' | translate }} {{ hourSelected }}.
						</p>
					</div>
					<div
						class="col-12"
						*ngIf="
							!form.get('radioDateProfessional')?.value && form.get('callDate')?.value && form.get('callTime')?.value
						"
					>
						<p class="fs-6 m-0">
							{{ 'claimConfirm.appointment.noProfessionalDate.summary.weCallYou' | translate }}
							{{ form.get('callDate')?.value.day }}/{{ form.get('callDate')?.value.month }}/{{
								form.get('callDate')?.value.year
							}}
							<span *ngIf="form.get('callTime')?.value.toLowerCase() !== 'indiferente'">
								{{ 'claimConfirm.appointment.noProfessionalDate.summary.at' | translate }}
								{{ form.get('callTime')?.value.toLowerCase() }}
							</span>
						</p>
					</div>
				</div>
			</ng-template>
		</mat-step>

		<mat-step [editable]="false">
			<ng-template matStepLabel> </ng-template>
			<ng-template matStepContent></ng-template>
		</mat-step>
	</mat-stepper>
	<div class="row">
		<div class="col-12 p-0 pt-4 mt-4 border-top d-flex justify-content-end">
			<button
				*ngIf="claimConfirmPart === 3 && form.get('sendFixer')?.value"
				[disabled]="form.invalid || !showStepSummary['repairAppointment']['show']"
				(click)="onSubmit()"
				class="btn btn-primary d-flex align-items-center justify-content-center w-100 w-md-initial"
			>
				<i class="icon hs-icon-check text-white"></i>
				{{ 'claimConfirm.send' | translate }}
			</button>
		</div>
	</div>
</form>
